import React, { useState, useEffect, useRef } from "react";
import { FeedbackWorkflowContext } from "./FeedbackWorkflowContext.tsx";
import QuestContext from "../../../../components/QuestWrapper";
import ThankYou from "./ThankYou.tsx";
import {
  FeedbackWorkflowModularProps,
  optionType,
  FeedbackWorkflowComponents,
  UiPropsInterface,
  FormDataItem,
  FileProp,
} from "./types.ts";
import General from "../../../../general";
import {
  DEFAULT_BRAND_THEME,
  DEFAULT_QUEST_THEME,
} from "../components/feedbackWorkflow.types.ts";

import FeedbackWorkflowApi from "../components/FeedbackWorkflowApi.ts";
import FeedbackWorkflowThemeManager from "../components/themeManager.ts";
import { useContext } from "react";
import config from "../../../../config";
import axios from "axios";
import Loader from "../../../../components/Login/Loader";
import showToast from "../../../../components/toast/toastService";
import QuestLabs from "../../../../components/QuestLabs";
import Modal from "../../../../components/Modules/Modal";
import TopBar from "../../../../components/Modules/TopBar";
import { ScreenCapture } from "react-screen-capture";
import imageCompression from "browser-image-compression";
import FeedbackWorkflowFunctions from "./FeedbackWorkflowFunctions.ts";
import FeedbackCardContainer from "./FeedbackCardContainer.tsx";
import GeneralFeedbackContent from "./GeneralFeedbackContent.tsx";
import BugContent from "./BugContent.tsx";
import FeatureContent from "./FeatureContent.tsx";

const FeedbackWorkflow: React.FC<FeedbackWorkflowModularProps> &
  FeedbackWorkflowComponents = ({
  userId,
  token,
  questId,
  ContactUs,
  GeneralFeedback,
  Headers,
  PrimaryButtonText = "Submit",
  ReportBug,
  RequestFeature,
  SecondaryButtonText = "Go to home!",
  contactUrl,
  iconColor,
  ratingStyle,
  starBorderColor,
  starColor,
  styleConfig,
  // questIds,
  isOpen,
  onClose,
  uniqueUserId,
  uniqueEmailId,
  variation,
  entityAuthenticationToken,
  children,
  isLoader = false,
  accent,
  title
}) => {
  const { apiKey, apiSecret, entityId, featureFlags, apiType, themeConfig, user } =
    useContext(QuestContext.Context);
  const [selectedOption, setSelectedOption] = useState<optionType | null>(null);
  const [selectedQuest, setSelectedQuest] = useState<string | null>(null);
  const [campaignVariationIds, setCampaignVariationIds] = useState<any>({});
  const [formdata, setFormdata] = useState<any[]>(
    []
  );
  const [questIds, setQuestIds] = useState<string[]>([]);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [submit, setSubmit] = useState<boolean>(false);

  const [answer, setAnswer] = useState<Record<string, string>>({});
  const [cardHovered, setCardHovered] = useState([false, false, false, false]);
  const [rating, setRating] = useState<number>(0);
  const [getUserId, setGetUserId] = useState<string>(userId || "");
  const [getUserToken, setGetUserToken] = useState<string>(token || "");

  const [questThemeData, setQuestThemeData] = useState({...DEFAULT_QUEST_THEME, accentColor : DEFAULT_QUEST_THEME.accentColor ? DEFAULT_QUEST_THEME.accentColor : accent});
  const [BrandTheme, setBrandTheme] = useState(DEFAULT_BRAND_THEME);
  const [sectionConfig, setSectionConfig] = useState({
    generalFeedback: true,
    reportBug: true,
    requestFeature: true,
    contactUs: true,
  });
  let BACKEND_URL =
    apiType == "STAGING" ? config.BACKEND_URL_STAGING : config.BACKEND_URL;

  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [screenshot, setScreenshot] = useState<FileProp | null>(null);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [file, setFile] = useState<FileProp | null>(null);

  const [uiProps, setUiprops] = useState<UiPropsInterface | null>(null);
  const [loading, setLoading] = useState<boolean>(false);


  useEffect(() => {
    if (isVisible == true) {
      document.body.classList.remove("q-feeback-noselect");
    } else {
      document.body.classList.add("q-feeback-noselect");
    }
    return () => {
      document.body.classList.remove("q-feeback-noselect");
    };
  }, [isVisible]);

  const closeModal = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    let target = e.target as Element;
    if (ref.current?.contains(target)) {
    } else {
      onClose && onClose();
    }
  };

  const uploadFileToBackend: any = async (file: any) => {
    setShowLoader(true);
    if (file?.size > 1000000) {
      try {
        // Resize the image to below 1MB
        const compressedImage = await imageCompression(file, {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          initialQuality: 1,
        });

        return await uploadFileToBackend(compressedImage);
      } catch (error) {
        return null;
      }
    }
    const formData = new FormData();
    formData.append("uploaded_file", file);
    try {
      let res = await axios.post(`${BACKEND_URL}api/upload-img`, formData, {
        headers: {
          userId: userId || getUserId,
          token: token || getUserToken,
          apiKey,
          apiSecret,
          "Content-Type": "form-data",
        },
      });
      if (
        res == null ||
        !res?.data ||
        res?.data.success == false ||
        !res?.data?.imageUrl
      ) {
      } else {
        setShowLoader(false);
        return res.data.imageUrl;
      }

      setShowLoader(false);
    } catch (error) {
      console.log(error);
      setShowLoader(false);
    }
  };

  const ref = React.useRef<HTMLDivElement>(null);

  let GeneralFunctions = new General("mixpanel", apiType, apiKey, entityId);

  useEffect(() => {
    GeneralFunctions.trackEvent(
      "quest-feedback-workflow-loaded",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId,
      true
    );
  }, []);

  useEffect(() => {
    if (questIds.length > 0) {
      setSelectedQuest(
        selectedOption == "GeneralFeedback"
          ? questIds[0]
          : selectedOption == "ReportBug"
          ? questIds[1]
          : questIds[2]
      );
    }
  }, [questIds, selectedOption]);

  const handleOptionClick = async (
    option: optionType,
    quest: string | undefined
  ) => {
    if (!quest) {
      option === "ContactUs" && contactUrl
        ? window.open(contactUrl, "_blank")
        : setSelectedOption(null);
      setSelectedOption(option);

      return;
    }
    if (uniqueUserId || uniqueEmailId) {
      let generalFunction = new General("", apiType);
      let userData = await generalFunction.getExternalLogin({
        apiType: apiType,
        uniqueUserId,
        entityId,
        userId,
        apiKey,
        apiSecret: "",
        token,
        uniqueEmailId,
        entityAuthenticationToken,
      });
      if (userData?.userId) {
        userId = userData?.userId;
        token = userData?.token;
        setGetUserId(userData?.userId);
        setGetUserToken(userData?.token);
      }
    }
    let header = {
      apiKey: apiKey,
      apisecret: apiSecret,
      userId: userId,
      token: token,
    };
    // let cookies = new Cookies();
    // let externalUserId = cookies.get("externalUserId");
    // let questUserId = cookies.get("questUserId");
    // let questUserToken = cookies.get("questUserToken");
    try {
      axios.post(
        `${BACKEND_URL}api/entities/${entityId}/users/${userId}/metrics/feedback-${quest}?userId=${userId}&questId=${quest}`,
        { count: 1 },
        { headers: header }
      );

      GeneralFunctions.trackEvent(
        `quest-feedback-${selectedOption}-click`,
        (uniqueUserId || userId || user.userId)!,
        {},
        true,
        !uniqueUserId
      );

    } catch (error) {
      GeneralFunctions.captureSentryException(error);
    }
    // if (
    //   !!externalUserId &&
    //   !!questUserId &&
    //   !!questUserToken &&
    //   externalUserId == uniqueUserId
    // ) {
    //   let header = {
    //     apiKey: apiKey,
    //     apisecret: apiSecret,
    //     userId: questUserId,
    //     token: questUserToken,
    //   };
    //   try {
    //     axios.post(
    //       `${BACKEND_URL}api/entities/${entityId}/users/${userId}/metrics/feedback-${quest}?userId=${userId}&questId=${quest}`,
    //       { count: 1 },
    //       { headers: header }
    //     );
    //   } catch (error) {
    //     GeneralFunctions.captureSentryException(error);
    //   }
    // } else if (uniqueUserId || uniqueEmailId) {
    //   let generalFunction = new General("", apiType);
    //   let userData = await generalFunction.getExternalLogin({
    //     apiType: apiType,
    //     uniqueUserId,
    //     entityId,
    //     userId,
    //     apiKey,
    //     apiSecret: "",
    //     token,
    //     uniqueEmailId,
    //     entityAuthenticationToken,
    //   });
    //   if (userData?.userId) {
    //     userId = userData?.userId;
    //     token = userData?.token;
    //   }

    //   // const body = {
    //   //   externalUserId: !!uniqueUserId && uniqueUserId,
    //   //   entityId: entityId,
    //   //   email: uniqueEmailId,
    //   // };

    //   // const headers = {
    //   //   apiKey: apiKey,
    //   //   apisecret: apiSecret,
    //   //   userId: userId,
    //   //   token: token,
    //   //   "entity-authentication-token": entityAuthenticationToken
    //   // };

    //   // axios
    //   //   .post(`${BACKEND_URL}api/users/external/login`, body, { headers })
    //   //   .then((res) => {
    //   //     let { userId, token } = res.data;
    //   //     let header = { ...headers, ...{ userId, token } };
    //   //     let cookies = new Cookies();
    //   //     const date = new Date();
    //   //     date.setHours(date.getHours() + 12);
    //   //     cookies.set("externalUserId", uniqueUserId, {
    //   //       path: "/",
    //   //       expires: date,
    //   //     });
    //   //     cookies.set("questUserId", userId, { path: "/", expires: date });
    //   //     cookies.set("questUserToken", token, { path: "/", expires: date });
    //   //     axios.post(
    //   //       `${BACKEND_URL}api/entities/${entityId}/users/${userId}/metrics/feedback-${quest}?userId=${userId}&questId=${quest}`,
    //   //       { count: 1 },
    //   //       { headers: header }
    //   //     );
    //   //   })
    //   //   .catch((error) => {
    //   //     console.error("Error:", error);
    //   //     GeneralFunctions.captureSentryException(error);
    //   //   });
    // }
    if (option === "ContactUs" && (contactUrl || uiProps?.contactUrl)) {
      window.open(contactUrl || uiProps?.contactUrl, "_blank");
    } else {
      setSelectedOption(option);
      setSelectedQuest(quest);
      setAnswer({});
    }
  };

  async function returnAnswers(index: number) {
    GeneralFunctions.trackEvent(
      "quest-feedback-workflow-submit-btn-click",
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId
    );

    GeneralFunctions.trackEvent(
      `quest-feedback-workflow-${selectedOption}-form-submitted`,
      (uniqueUserId || userId || user.userId)!,
      {},
      true,
      !uniqueUserId
    );

    GeneralFunctions.fireTrackingEvent(
      `quest_feedback_workflow_${selectedOption}_form_submitted`,
      `feedback_workflow_${selectedOption}_form`
    );
    if (uniqueEmailId || uniqueUserId) {
      let generalFunction = new General("", apiType);
      let userData = await generalFunction.getExternalLogin({
        apiType: apiType,
        uniqueUserId,
        entityId,
        userId,
        apiKey,
        apiSecret: "",
        token,
        uniqueEmailId,
        entityAuthenticationToken,
      });
      if (userData?.userId) {
        userId = userData?.userId;
        token = userData?.token;
        setGetUserId(userData?.userId);
        setGetUserToken(userData?.token);
      }
    }
    // const headers = {
    //   apiKey: apiKey,
    //   apisecret: apiSecret,
    //   userId: userId,
    //   token: token,
    // };

    // let cookies = new Cookies();
    // let externalUserId = cookies.get("externalUserId");
    // let questUserId = cookies.get("questUserId");
    // let questUserToken = cookies.get("questUserToken");

    GeneralFunctions.fireTrackingEvent(
      `quest_feedback_workflow-${entityId}`,
      "feedback_workflow"
    );
    // const headers = {
    //   apiKey: apiKey,
    //   apisecret: apiSecret,
    //   userId: userId,
    //   token: token,
    // };
    // let cookies = new Cookies();
    // let externalUserId = cookies.get("externalUserId");
    // let questUserId = cookies.get("questUserId");
    // let questUserToken = cookies.get("questUserToken");

    if (Object.keys(answer).length !== 0) {
      const ansArr = formdata[index].map((ans: any) => ({
        answers: Array.isArray(answer[ans?.criteriaId])
          ? answer[ans?.criteriaId]
          : [String(answer[ans?.criteriaId]) || ""],
        actionId: ans?.criteriaId || "",
      }));

      let header = {
        apiKey: apiKey,
        apisecret: apiSecret,
        userId: userId,
        token: token,
      };
      setResult(header, header.userId || getUserId);

      function setResult(headers: { userId?: string }, userId: string) {
        const request = `${BACKEND_URL}api/v2/entities/${entityId}/campaigns/${selectedQuest}/verify`;
        const requestData = {
          actions: ansArr,
          campaignVariationId: campaignVariationIds[selectedQuest || ""],
        };
        setShowLoader(true);
        axios
          .post(request, requestData, { headers: headers })
          .then((response) => {
            if (response.data.success) {
              setSubmit(true);
              setTimeout(() => {
                setSubmit(false);
                setSelectedOption(null);
              }, 4000);
              axios.post(
                `${BACKEND_URL}api/entities/${entityId}/users/${userId}/metrics/feedback-${selectedQuest}-com?userId=${userId}&questId=${selectedQuest}`,
                { count: 1 },
                { headers: headers }
              );
            } else {
              console.log(response.data.error);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            GeneralFunctions.captureSentryException(error);
          })
          .finally(() => {
            setShowLoader(false);
            setRating(0);
          });
      }
    } else {
      showToast.error("Please fill in all required fields.");
    }
  }

  const handleBackClick = () => {
    GeneralFunctions.fireTrackingEvent(
      `quest_feedback_workflow_${selectedOption}_form_closed`,
      `feedback_workflow_${selectedOption}_form`
    );
    setSelectedOption(null);
    setRating(0);
    setFile(null);
    setScreenshot(null);
  };

  const feedbackWOrkflowAPi = new FeedbackWorkflowApi(apiType);

  useEffect(() => {
    const fetchCampaign = async () => {
      if (!entityId) return;

      try {
        const userAuth = await feedbackWOrkflowAPi.getUserAuth({
          apiKey,
          entityId,
          uniqueUserId,
          uniqueEmailId,
          userId,
          token,
        });

        if (!userAuth) return;

        const headers = {
          apiKey,
          apiSecret,
          userId: userAuth.userId,
          token: userAuth.token,
        };

        const params = new URLSearchParams();
        params.set("platform", "REACT");
        if (variation) params.set("variation", variation);

        const response = await feedbackWOrkflowAPi.fetchCampaignData(
          entityId,
          questId,
          headers,
          variation
        );
        if (response?.metadata?.sectionConfig) {
          setSectionConfig(response?.metadata?.sectionConfig);
        }
        if (response.sdkConfig?.uiProps?.questThemeData) {
          setQuestThemeData({...response.sdkConfig.uiProps.questThemeData,accentColor : response.sdkConfig.uiProps.questThemeData.accentColor ? response.sdkConfig.uiProps.questThemeData.accentColor : accent});
          if (response.sdkConfig.uiProps.BrandTheme) {
            setBrandTheme(response.sdkConfig.uiProps.BrandTheme.properties);
          }
        }

        setUiprops(
          (response?.sdkConfig && response?.sdkConfig.uiProps) || null
        );
        if (!contactUrl) {
          contactUrl = response?.sdkConfig?.uiProps?.contactUrl;
        }
        // let questData = response.data.data;
        let questData = response;

        setCampaignVariationIds(
          questData?.childCampaignActions?.reduce((acc: any, cur: any) => {
            acc[cur.campaignId] = cur.campaignVariationId;
            return acc;
          }, {})
        );

        // setting form Data
        let actions = questData?.childCampaignActions?.map(
          (childQuest: any) => {
            questIds.push(childQuest?.campaignId);
            return childQuest.actions.map((action: any) => ({
              type: action.actionType,
              question: action.title,
              options: action.options,
              criteriaId: action.actionId,
              required: action.isRequired,
              placeholder: action?.metadata?.placeholder,
            }));
          }
        );
        setFormdata(actions);
        setQuestIds((prev) => [...prev, ...questIds]);
      } catch (error) {
        GeneralFunctions.captureSentryException(error);
      }
    };

    fetchCampaign();
  }, [questId]);

  const handleUpdate = (e: any, id: string, j: string, k?: number) => {
    setAnswer({
      ...answer,
      [id]: e.target.value || k,
    });
  };

  const handleThanks = () => {
    setSubmit(false);
    setSelectedOption(null);
  };

  const handleRemove = (id: string) => {
    setAnswer({
      ...answer,
      [id]: "",
    });
  };

  useEffect(() => {
    if (isVisible) {
      const overlayElement = document.querySelector(
        ".overlay.highlighting"
      ) as HTMLElement;
      if (overlayElement) {
        overlayElement.style.borderColor = "blue";
      } else {
        console.error("Overlay element not found");
      }
    }
  }, [isVisible]);

  let feedbackWorkflowFunctions;
  feedbackWorkflowFunctions = new FeedbackWorkflowFunctions(
    ContactUs || uiProps?.ContactUs,
    GeneralFeedback || uiProps?.generalFeedback,
    Headers || uiProps?.Headers,
    PrimaryButtonText || uiProps?.PrimaryButtonText,
    ReportBug || uiProps?.bugReport,
    RequestFeature || uiProps?.featureRequest,
    SecondaryButtonText || uiProps?.SecondaryButtonText,
    contactUrl || uiProps?.contactUrl,
    iconColor || uiProps?.iconColor,
    // questThemeData || uiProps?.questThemeData,
    ratingStyle || uiProps?.ratingStyle,
    uiProps?.showFooter !== undefined ? uiProps?.showFooter : true,
    starBorderColor || uiProps?.starBorderColor,
    starColor || uiProps?.starColor
  );

  const themeManager = new FeedbackWorkflowThemeManager(
    themeConfig,
    styleConfig || uiProps?.styleConfig,
    questThemeData,
    BrandTheme,
    uiProps
  );

  if (
    featureFlags[config.FLAG_CONSTRAINTS.FeedbackWorkflowFlag]?.isEnabled ==
    false
  ) {
    return <div></div>;
  }

  const handleScreenCapture = async (capture: string) => {
    try {
      isLoader &&  setLoading(true); 
      setIsVisible(true);
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();
      const time = hours + ":" + minutes + ":" + seconds;
      let fileName = "screenshot" + time + ".jpg";

      const response = await axios.get(capture, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "image/jpeg" });
      const file = new File([blob], fileName, { type: "image/jpeg" });
      setScreenshot(file);
    } catch (error) {
      console.error("An error occurred while fetching the image:", error);
    } finally {
      isLoader &&  setLoading(false);
    }
  };


  useEffect(() => {
    styleConfig?.ScreenShot?.BorderColor &&
      document.documentElement.style.setProperty(
        "--q-screenshot-border-color",
        styleConfig?.ScreenShot?.BorderColor
      );
    styleConfig?.ScreenShot?.BorderWidth &&
      document.documentElement.style.setProperty(
        "--q-screenshot-border-width",
        styleConfig?.ScreenShot?.BorderWidth
      );
    styleConfig?.ScreenShot?.Background &&
      document.documentElement.style.setProperty(
        "--q-screenshot-container-background",
        styleConfig?.ScreenShot?.Background
      );
    styleConfig?.ScreenShot?.ScreenShotBackground &&
      document.documentElement.style.setProperty(
        "--q-screenshot-inner-container-background",
        styleConfig?.ScreenShot?.ScreenShotBackground
      );
    styleConfig?.ScreenShot?.CrosshairColor &&
      document.documentElement.style.setProperty(
        "--q-screenshot-crosshair-color",
        styleConfig?.ScreenShot?.CrosshairColor
      );
  }, [styleConfig?.ScreenShot]);

  

  const contextValue = {
    ContactUs,
    handleThanks,
    submit,
    ref,
    isVisible,
    showLoader,
    selectedOption,
    handleBackClick,
    onClose,
    apiType,
    apiKey,
    entityId,
    handleOptionClick,
    questIds,
    setCardHovered,
    cardHovered,
    setIsVisible,
    screenshot,
    handleUpdate,
    returnAnswers,
    formdata,
    handleRemove,
    setScreenshot,
    uploadFileToBackend,
    inputRef,
    file,
    setFile,
    rating,
    setRating,
    feedbackWorkflowFunctions,
    themeManager,
  };

  if(loading) {
    return <Loader />
  }
  if (formdata.length === 0) return null;

  return (
    <FeedbackWorkflowContext.Provider value={contextValue}>
      <Modal
        isOpen={isOpen}
        onClose={onClose || (() => {})}
        style={{
          padding: 0,
          background: "transparent",
          ...themeManager.getModalStyles(),
        }}
      >
        <ScreenCapture onEndCapture={handleScreenCapture}>
          {({ onStartCapture }: any) => (
            <div
              className="q_modal_overlay"
              onClick={(e) => closeModal(e)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "transparent",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isVisible ? 1 : 0,
              }}
            >
              {!submit && (
                <div
                  className="q_modal"
                  ref={ref}
                  id="modal_box"
                  style={{
                    padding: 0,
                    background: "transparent",
                    opacity: isVisible ? 1 : 0,
                    ...themeManager.getModalStyles(),
                  }}
                >
                  {showLoader && <Loader />}
                  <div
                    className="q-fw-div"
                    style={{
                      ...themeManager?.getFormStyles(),
                    }}
                    id="disabledClick"
                  >
                    {selectedOption && !submit ? (
                      <div>
                        <TopBar
                          style={{
                            topbarStyle:
                              themeManager.getTopBarStyles().topbarStyle,
                            headingStyle:
                              themeManager.getTopBarStyles().headingStyle,
                            descriptionStyle:
                              themeManager.getTopBarStyles().descriptionStyle,
                          }}
                          description={
                            selectedOption == "ContactUs"
                              ? Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                                ? feedbackWorkflowFunctions?.getHeaders()[3]
                                    ?.subHeading
                                : feedbackWorkflowFunctions?.getContactUs()
                                    ?.description ||
                                  "Invite other admins and moderators"
                              : selectedOption == "RequestFeature"
                              ? Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                                ? feedbackWorkflowFunctions?.getHeaders()[2]
                                    ?.subHeading
                                : feedbackWorkflowFunctions.getRequestFeature()
                                    ?.formDescription ||
                                  "How can we make it better"
                              : selectedOption == "ReportBug"
                              ? Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                                ? feedbackWorkflowFunctions?.getHeaders()[1]
                                    ?.subHeading
                                : feedbackWorkflowFunctions?.getReportBug()
                                    .formDescription || "Describe your issue"
                              : Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                              ? feedbackWorkflowFunctions?.getHeaders()[0]
                                  ?.subHeading
                              : feedbackWorkflowFunctions?.getGeneralFeedback()
                                  .formDescription ||
                                "Give general feedback on this page"
                          }
                          heading={
                            selectedOption == "ContactUs"
                              ? Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                                ? feedbackWorkflowFunctions?.getHeaders()[3]
                                    ?.heading
                                : feedbackWorkflowFunctions?.getContactUs()
                                    ?.heading || "Contact us"
                              : selectedOption == "RequestFeature"
                              ? Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                                ? feedbackWorkflowFunctions?.getHeaders()[2]
                                    ?.heading
                                : feedbackWorkflowFunctions.getRequestFeature()
                                    .formHeading || "Request a Feature"
                              : selectedOption == "ReportBug"
                              ? Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                                ? feedbackWorkflowFunctions?.getHeaders()[1]
                                    ?.heading
                                : feedbackWorkflowFunctions?.getReportBug()
                                    ?.formHeading || "Report a Bug"
                              : Array.isArray(
                                  feedbackWorkflowFunctions?.getHeaders()
                                )
                              ? feedbackWorkflowFunctions?.getHeaders()[0]
                                  ?.heading
                              : feedbackWorkflowFunctions?.getGeneralFeedback()
                                  ?.formHeading || "General Feedback"
                          }
                          iconColor={feedbackWorkflowFunctions.geticonColor()}
                          onClose={handleBackClick}
                        />
                        <div style={{ padding: "20px" }}>
                          {selectedOption === "GeneralFeedback" && (
                            <GeneralFeedbackContent
                              starColor={feedbackWorkflowFunctions.getstarColor()}
                              handleSubmit={() =>
                                returnAnswers && returnAnswers(0)
                              }
                              handleUpdate={handleUpdate}
                              formdata={formdata[0]}
                              starBorderColor={feedbackWorkflowFunctions.getstarBorderColor()}
                              answer={answer}
                              handleRemove={handleRemove}
                              ratingStyle={feedbackWorkflowFunctions.getratingStyle()}
                              iconColor={feedbackWorkflowFunctions.geticonColor()}
                              buttonStyle={{
                                ...themeManager.getPrimaryButtonStyles(),
                              }}
                              PrimaryButtonText={feedbackWorkflowFunctions.getPrimaryButtonText()}
                              StarStyle={themeManager.getStarStyles()}
                              labelStyle={themeManager.getLabelStyles()}
                              isVisible={isVisible}
                              setIsVisible={setIsVisible}
                              screenshot={screenshot}
                              setScreenshot={setScreenshot}
                              onStartCapture={onStartCapture}
                              uploadFileToBackend={uploadFileToBackend}
                              inputRef={inputRef}
                              file={file}
                              setFile={setFile}
                              rating={rating}
                              setRating={setRating}
                            />
                          )}

                          {selectedOption === "ReportBug" && (
                            <BugContent
                              ratingStyle={feedbackWorkflowFunctions.getratingStyle()}
                              handleSubmit={() =>
                                returnAnswers && returnAnswers(1)
                              }
                              handleUpdate={handleUpdate}
                              formdata={formdata[1]}
                              answer={answer}
                              handleRemove={handleRemove}
                              PrimaryButtonText={feedbackWorkflowFunctions.getPrimaryButtonText()}
                              buttonStyle={themeManager.getPrimaryButtonStyles()}
                              isVisible={isVisible}
                              setIsVisible={setIsVisible}
                              screenshot={screenshot}
                              setScreenshot={setScreenshot}
                              onStartCapture={onStartCapture}
                              uploadFileToBackend={uploadFileToBackend}
                              inputRef={inputRef}
                              file={file}
                              setFile={setFile}
                              BrandTheme={BrandTheme}
                              rating={rating}
                              setRating={setRating}
                              starBorderColor={feedbackWorkflowFunctions.getstarBorderColor()}
                            />
                          )}
                          {selectedOption === "RequestFeature" && (
                            <FeatureContent
                              handleSubmit={() =>
                                returnAnswers && returnAnswers(2)
                              }
                              handleUpdate={handleUpdate}
                              formdata={formdata[2]}
                              answer={answer}
                              handleRemove={handleRemove}
                              PrimaryButtonText={feedbackWorkflowFunctions.getPrimaryButtonText()}
                              buttonStyle={themeManager.getPrimaryButtonStyles()}
                              isVisible={isVisible}
                              setIsVisible={setIsVisible}
                              screenshot={screenshot}
                              setScreenshot={setScreenshot}
                              onStartCapture={onStartCapture}
                              uploadFileToBackend={uploadFileToBackend}
                              inputRef={inputRef}
                              file={file}
                              setFile={setFile}
                              BrandTheme={BrandTheme}
                              rating={rating}
                              setRating={setRating}
                            />
                          )}
                          {selectedOption === "ContactUs" && <div></div>}
                        </div>

                        {feedbackWorkflowFunctions.getshowFooter() && (
                          <QuestLabs
                            style={themeManager?.getFooterStyles()?.FooterStyle}
                            textStyle={
                              themeManager?.getFooterStyles()?.FooterTextStyle
                            }
                            iconStyle={
                              themeManager?.getFooterStyles()?.FooterIcon
                            }
                            text={themeManager?.getFooterStyles()?.FooterText}
                            link={themeManager?.getFooterStyles()?.FooterLink}
                          />
                        )}
                      </div>
                    ) : !submit ? (
                      <FeedbackCardContainer
                        onClose={onClose}
                        GeneralFunctions={GeneralFunctions}
                        handleOptionClick={handleOptionClick}
                        setCardHovered={setCardHovered}
                        cardHovered={cardHovered}
                        questIds={questIds}
                        title={title}
                        sectionConfig={sectionConfig}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}
              {children}
            </div>
          )}
        </ScreenCapture>
      </Modal>
    </FeedbackWorkflowContext.Provider>
  );
};

FeedbackWorkflow.ThankYou = ThankYou;

export default FeedbackWorkflow;
